import React, { useState } from 'react';
import { IMortgage } from '../../../../Interfaces/IMortgage';
import { Box, Button, Collapse } from '@mui/material';
import CompanyModifiedBaseInformation from './Beneficiary/CompanyModifiedBaseInformation';
import { IPerson } from '../../../../Interfaces/IPerson';
import { ICompany } from '../../../../Interfaces/ICompany';
import { GridBaseData } from '../../../../Person/GridBaseData';
import {
  getNewCompany,
  getNewPerson,
} from '../../../../services/dialog.service';

interface IProps {
  mortgageObject: IMortgage;
  setMortgageObject: Function;
}

export const Beneficiary: React.FC<IProps> = ({
  mortgageObject,
  setMortgageObject,
}) => {
  console.log(mortgageObject);
  const [isCompany, setIsCompany] = useState<boolean | null>(
    mortgageObject.BeneficiaryDetails &&
      ('idPerson' in mortgageObject.BeneficiaryDetails ||
        'idCompany' in mortgageObject.BeneficiaryDetails)
      ? 'idCompany' in mortgageObject.BeneficiaryDetails
        ? true
        : false
      : null
  );

  const handleRadioChange = (value: boolean) => {
    setIsCompany(value);
    setMortgageObject({
      ...mortgageObject,
      BeneficiaryDetails: value ? getNewCompany : getNewPerson,
    });
  };
  const updateCreditor = (creditorObject: IPerson | ICompany) => {
    if (creditorObject !== null) {
      setMortgageObject({
        ...mortgageObject,
        BeneficiaryDetails: creditorObject,
      });
    }
  };

  return (
    <>
      <Box>
        <Box
          sx={{
            display: 'flex',
            border: '1px solid',
            borderColor: 'text.primary',
            borderTopLeftRadius: 8,
            borderTopRightRadius: 8,
            ...(isCompany === null
              ? { borderBottomLeftRadius: 8, borderBottomRightRadius: 8 }
              : { borderBottom: '1px solid #ccc' }),
            overflow: 'hidden',
          }}
        >
          <Button
            variant={
              isCompany === null
                ? 'outlined'
                : isCompany
                  ? 'contained'
                  : 'outlined'
            }
            onClick={() => handleRadioChange(true)}
            sx={{
              border: 'none',
              borderColor: 'text.primary',
              ...(isCompany
                ? {}
                : {
                    color: 'text.primary',
                    borderRight: '1px solid #ccc',
                  }),
              flex: 1,
              borderRadius: 0,
              '&:hover': {
                borderColor: 'white',
              },
            }}
          >
            Gläubiger ist ein Unternehmen.
          </Button>
          <Button
            variant={
              isCompany === null
                ? 'outlined'
                : !isCompany
                  ? 'contained'
                  : 'outlined'
            }
            onClick={() => handleRadioChange(false)}
            sx={{
              border: 'none',
              borderColor: 'text.primary',
              ...(isCompany !== null && !isCompany
                ? {}
                : {
                    color: 'text.primary',
                    borderLeft: '1px solid #ccc',
                  }),
              flex: 1,
              borderRadius: 0,
              '&:hover': {
                borderColor: 'white',
              },
            }}
          >
            Gläubiger ist eine Privatperson.
          </Button>
        </Box>
        {isCompany !== null && (
          <Box
            sx={{
              border: '1px solid',
              borderColor: 'text.primary',
              borderTop: 'none',
              borderBottomLeftRadius: 8,
              borderBottomRightRadius: 8,
              p: 2,
              minHeight: 350, // 👈 verhindert das Einklappen beim Wechsel
            }}
          >
            <Collapse in={isCompany}>
              {isCompany && mortgageObject.BeneficiaryDetails && (
                <CompanyModifiedBaseInformation
                  key={mortgageObject.id}
                  companyObject={mortgageObject.BeneficiaryDetails as ICompany}
                  setCompanyObject={updateCreditor}
                />
              )}
            </Collapse>
            <Collapse in={!isCompany}>
              {!isCompany && mortgageObject.BeneficiaryDetails && (
                <GridBaseData
                  key={
                    (mortgageObject.BeneficiaryDetails as IPerson)?.Postcode ??
                    ''
                  }
                  personObject={mortgageObject.BeneficiaryDetails as IPerson}
                  personArray={[]}
                  setPersonObject={updateCreditor}
                  disableContactInformations={true}
                  showDeathSettings={false}
                  forceDeathSettings={false}
                  forceAdress={true}
                  disableDeathDateWarning={true}
                  mt={0}
                />
              )}
            </Collapse>
          </Box>
        )}
      </Box>
    </>
  );
};
